import type { FC } from 'react'
import type { ButtonProps } from 'antd/lib/button'
import { Button as AntdButton } from 'antd'

const Button: FC<ButtonProps> = ({ children, className = '', ...props }) => {
    return (
        <AntdButton className={`customAntdButton ${className}`} {...props}>
            {children}
        </AntdButton>
    )
}

export default Button
